import { render, staticRenderFns } from "./ActiveCustomersReport.vue?vue&type=template&id=4691f687&"
import script from "./ActiveCustomersReport.vue?vue&type=script&lang=js&"
export * from "./ActiveCustomersReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports